import * as React from 'react';
import { useSelector } from 'react-redux';
import { IPublishTermsService } from '../../../../../../redux/reducers';
import { selectServiceById } from '../../../../../../selectors/publishTerms';
import { IUnavailableReasonOwnProps } from './types';
import { UnavailableReason } from './UnavailableReason';

export const UnavailableReasonContainer = (props: IUnavailableReasonOwnProps) => {
  const { serviceId } = props;

  const service = useSelector(selectServiceById(serviceId)) as IPublishTermsService;

  const { unavailableReasonType } = service;

  if (!unavailableReasonType) {
    return null;
  }

  return <UnavailableReason reasonType={unavailableReasonType} />;
};
